var _defs, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicAnimales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEDD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FED7AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "animalGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA580C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C2410C"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FDBA74",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48,22 C 45,22 44,25 45,27 C 46,29 50,29 51,27 C 52,25 51,22 48,22 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 34)",
    filter: "drop-shadow(0px 3px 2px rgba(194, 65, 12, 0.2))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -16,-2 L -18,-16 L -6,-10 L 0,-14 L 6,-10 L 18,-16 L 16,-2 L 10,8 L -10,8 Z",
    fill: "url(#animalGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -15,-3 L -16.5,-12.5 L -8.5,-8 Z",
    fill: "#FFF7ED",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15,-3 L 16.5,-12.5 L 8.5,-8 Z",
    fill: "#FFF7ED",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -16,-2 C -10,2 -6,3 -6,8 L -10,8 Z",
    fill: "#FFF7ED",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16,-2 C 10,2 6,3 6,8 L 10,8 Z",
    fill: "#FFF7ED",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-3,8 3,8 0,11",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -9,-2 C -8,0 -6,0 -5,-2",
    fill: "none",
    stroke: "#FFF7ED",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9,-2 C 8,0 6,0 5,-2",
    fill: "none",
    stroke: "#FFF7ED",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicAnimales);
export default __webpack_public_path__ + "static/media/topic_animales.fbd676795b873c260289dba9ccea2d22.svg";
export { ForwardRef as ReactComponent };